import type { ReactElement } from 'react';

export type IconName =
  | 'grid'
  | 'chat'
  | 'calendar'
  | 'signal'
  | 'alert'
  | 'clock'
  | 'check'
  | 'checks'
  | 'search'
  | 'logout'
  | 'user'
  | 'send'
  | 'note'
  | 'phone'
  | 'video'
  | 'inbox'
  | 'sparkle'
  | 'robot'
  | 'chevron-left'
  | 'chevron-right'
  | 'lock'
  | 'dot'
  | 'settings'
  | 'card'
  | 'panel'
  | 'plus'
  | 'x'
  | 'trend-up'
  | 'trend-down'
  | 'trend-flat'
  | 'image'
  | 'mic'
  | 'download'
  | 'paperclip'
  | 'play'
  | 'pause'
  | 'eye'
  | 'eye-off'
  | 'team';

const PATHS: Readonly<Record<IconName, string>> = {
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  chat: 'M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-5.4A8 8 0 1 1 21 12z',
  calendar:
    'M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v12A1.5 1.5 0 0 1 18.5 20h-13A1.5 1.5 0 0 1 4 18.5zM4 10h16M8.5 3v4M15.5 3v4',
  signal:
    'M5.5 17.5a9 9 0 0 1 0-11M18.5 6.5a9 9 0 0 1 0 11M8.6 14.4a4.5 4.5 0 0 1 0-4.8M15.4 9.6a4.5 4.5 0 0 1 0 4.8M12 12h.01',
  alert: 'M12 4.5 2.8 20h18.4zM12 10v4.5M12 17.4h.01',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.2V12l3.2 2',
  check: 'M4.5 12.5 9.5 17.5 19.5 6.5',
  checks: 'M2.5 12.5 6.5 16.5 14 8M11 15.5 12.5 17 21.5 7',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20.5 20.5 16 16',
  logout:
    'M14 7V5.5A1.5 1.5 0 0 0 12.5 4h-7A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20h7a1.5 1.5 0 0 0 1.5-1.5V17M9.5 12h11M17.5 8.5 21 12l-3.5 3.5',
  user: 'M20 20.5c0-3.6-3.6-5.5-8-5.5s-8 1.9-8 5.5M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  team: 'M16.5 20c0-2.9-2.5-4.5-6-4.5s-6 1.6-6 4.5M10.5 12.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM16 5.6a3.4 3.4 0 0 1 0 6.3M19.5 20c0-2.2-1-3.7-2.8-4.4',
  send: 'M21 3 3 10.5l7.5 3L14 21z',
  note: 'M6 3.5h9L19 8v12.5H6zM14.5 3.8V8.2H19',
  phone:
    'M6.2 3.5h3l1.5 4-2 1.4a12 12 0 0 0 6.4 6.4l1.4-2 4 1.5v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4.2 5.7a2 2 0 0 1 2-2.2z',
  video:
    'M4 7.5A1.5 1.5 0 0 1 5.5 6h8A1.5 1.5 0 0 1 15 7.5v9A1.5 1.5 0 0 1 13.5 18h-8A1.5 1.5 0 0 1 4 16.5zM15 11l5-3v8l-5-3z',
  inbox: 'M4 13.5 6.5 5h11L20 13.5V19H4zM4 13.5h4.5l1 2.5h5l1-2.5H20',
  sparkle:
    'M12 3.5 13.9 9l5.6 1.9-5.6 1.9L12 18.5 10.1 12.8 4.5 10.9 10.1 9zM18.5 16.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z',
  robot:
    'M6.5 8.5h11A1.5 1.5 0 0 1 19 10v8a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18v-8a1.5 1.5 0 0 1 1.5-1.5zM12 8.5V5.5M12 4.3h.01M9.5 13h.01M14.5 13h.01M9.5 16.5h5M3 12.5v3M21 12.5v3',
  'chevron-left': 'M14.5 5.5 8 12l6.5 6.5',
  'chevron-right': 'M9.5 5.5 16 12l-6.5 6.5',
  lock: 'M6 10.5h12V20H6zM8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5',
  /* Circulo cheio, centrado exatamente em 12,12. Existe para o slot de status da
     lista de conversas: o balao (`chat`) tem rabinho ate (4, 20.5), o que joga a
     massa para cima e a direita e faz o glifo parecer torto dentro de um circulo
     de 16 px. Aqui nao ha o que desalinhar. */
  dot: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z',
  card: 'M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5zM3 10.5h18M6.5 14.5h3',
  panel: 'M4 5.5h16v13H4zM14.5 5.5v13',
  plus: 'M12 5v14M5 12h14',
  x: 'M6 6l12 12M18 6 6 18',
  'trend-up': 'M3 17l6-6 4 4 8-8M21 7h-5M21 7v5',
  'trend-down': 'M3 7l6 6 4-4 8 8M21 17h-5M21 17v-5',
  'trend-flat': 'M4 12h16M17 9l3 3-3 3',
  image: 'M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6',
  download: 'M12 3v12M7.5 10.5 12 15l4.5-4.5M4 19h16',
  play: 'M8 5.5v13l11-6.5z',
  pause: 'M9.5 5.5v13M14.5 5.5v13',
  paperclip: 'M20.5 11.5 12 20a5 5 0 0 1-7-7l8.5-8.5a3.5 3.5 0 0 1 5 5L10 18a2 2 0 0 1-3-3l8-8',
  mic: 'M12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3zM5 11a7 7 0 0 0 14 0M12 18v3',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12S18 18.5 12 18.5 2.5 12 2.5 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  // O corte atravessa o olho inteiro: um risco curto le-se como arranhado no icone.
  'eye-off':
    'M3 3l18 18M10.6 6.1A9.7 9.7 0 0 1 12 6c6 0 9.5 6 9.5 6a17 17 0 0 1-2.6 3.3M6.6 8.2A17 17 0 0 0 2.5 12S6 18 12 18a9.4 9.4 0 0 0 3.2-.5M9.9 9.9a3 3 0 0 0 4.2 4.2',
};

interface IconProps {
  readonly name: IconName;
  readonly size?: number;
  readonly strokeWidth?: number;
}

export function Icon({ name, size = 18, strokeWidth = 1.7 }: IconProps): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
